//imports
import { all } from 'redux-saga/effects';

//Views
import createUnsubscribedContactSagas from 'Modules/unsubscribedContacts/.components/createUnsubscribedContact/redux/saga';
import deleteUnsubscribedContactSagas from 'Modules/unsubscribedContacts/.components/deleteUnsubscribedContact/redux/saga';


//merge sagas
export default function* rootSaga() {
    yield all([
        createUnsubscribedContactSagas(),
        deleteUnsubscribedContactSagas()
    ]);
}